import Head from 'next/head';
import { Box, Container, Typography} from '@mui/material';
import { DashboardLayout } from '../dashboard-layout';

import {useAuth} from "../../contexts/AuthContext"

import 'firebase/compat/firestore';
import { useParams } from 'react-router-dom';
import OrderCard from './OrderCard';

const AddOrder = () => {
  const { id } = useParams();

  const { currentUser } = useAuth();
  
  return (
    <>
      <Head>
        <title>
          Modifier livraison
        </title>
      </Head>
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          py: 3
        }}
      >
        <Container maxWidth="md">
          <Typography
            sx={{ mb: 3 }}
            variant="h4"
          >
            Modifier les détails de la livraison
          </Typography>
          <OrderCard orderId={id} isUpdate={true} fullSupport={currentUser.uid === "ntog5my06ZhXQwVNT9eO7GlnWpn2"}/>
          {/* <Box sx={{ mt: 3 }}>
            <OrdersFullPanel />
          </Box> */}
        </Container>
      </Box>
    </>
  );
}

AddOrder.getLayout = (page) => (
  <DashboardLayout>
    {page}
  </DashboardLayout>
);

export default AddOrder;
